<template>
  <nav aria-label="main navigation" class="navbar has-shadow" role="navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item logo-container" to="/">
        <img
            v-if="!isWhiteLabeled"
            class="logo-image container-margin"
            src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-03.svg"
            style="margin-left:45px"
        />
        <img
            v-else
            class="logo-image container-margin"
            :src="expandedLogoUrl"
            style="margin-left:45px"
        />
      </router-link>
      <a
          :class="{'is-active':showHamburger}"
          aria-expanded="false"
          aria-label="menu"
          class="navbar-burger burger"
          data-target="navbarBasic"
          role="button"
          @click="showHamburger = !showHamburger"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasic" :class="{'is-active':showHamburger}" class="navbar-menu">
      <div class="navbar-start">
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <NotificationBell/>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-item navbar-link">My Account</a>
          <div class="navbar-dropdown is-boxed" style="overflow: hidden">
            <router-link :to="`/profiles/${this.$store.state.auth.user.id}`" class="navbar-item">My Profile
            </router-link>
            <a class="navbar-item" @click="logOut">Logout</a>
            <LoginToSIS />
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import Group from "@/models/lms/Group";
import NotificationBell from "@/components/global/NotificationBell.vue";
import LoginToSIS from "@/components/layout/LoginToSIS.vue";
import User from "@/models/lms/User";

export default {
  name: "Navbar",
  components: {LoginToSIS, NotificationBell},
  data: function () {
    return {
      showHamburger: false,
    };
  },
  computed: {
    ...mapGetters("tenant", ["isWhiteLabeled", "expandedLogoUrl"]),
    numberOfForums() {
      return Group.query().count();
    },
    forums() {
      return Group.query().get()
    },
    highlight() {
      return this.$route.meta.highlight ?? null
    },
    ...mapState({
      guardian(state) {
        return state.guardian;
      },
    })
  },
  methods: {
    logOut() {
      this.$cookies.remove("lmsAccessToken");
      this.$cookies.remove("lmsTenantId");
      this.$cookies.remove("tenant_storage");
      this.$cookies.remove("sisAccessToken");
      this.$cookies.remove("sisTenantId");
      this.$cookies.remove("SecondRefresh");
      localStorage.removeItem('lmsAccessToken');
      this.$store.dispatch("tenant/logout");
      const slug = this.$cookies.get('tenant_slug') ? this.$cookies.get('tenant_slug') : '';
      const is_white_labeled = this.$cookies.get('tenant_is_white_labeled') ?? null;
      if (is_white_labeled){
        window.location.href = `/login/${slug}`;
      }
      else{
        window.location.href = `/login`;
      }
    },
  }
};
</script>


<style lang="scss" scoped>

@media (min-width: 1088px) {
  .navbar-item.is-hoverable:hover .navbar-dropdown {
    display: block;
  }
}

.logo-image {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  height: auto;

  &.container-margin {
    @media screen and (min-width: 1025px) {
      margin-left: 45px;
    }
  }
}

.logo-container {
  width: 20vw;
  @media screen and (max-width: 1087px) {
    margin-right: auto !important;
    width: 33vw;
  }
}

.hidden-logo {
  width: 33vw;
  margin-right: auto;
  @media screen and (min-width: 1088px) {
    display: none;
  }
}
</style>
